<template>
    <div id="map" v-if="mapSection.fields">
        <gmap-map :center="{lat: parseFloat(mapSection.fields.latitude.value), lng: parseFloat(mapSection.fields.longitude.value)}" :zoom="map.zoom" :tilt="map.tilt" :options="map.options" style="width: 100%; height: 100%">
            <gmap-marker v-if="mapSection.fields.marker.value" :position="{lat: parseFloat(mapSection.fields.latitude.value), lng: parseFloat(mapSection.fields.longitude.value)}" :clickable="false" :draggable="false" :icon="'/uploads/'+mapSection.fields.marker.value[0]"></gmap-marker>
        </gmap-map>
    </div>
</template>

<script> 
import _find from 'lodash/find'
export default {
    name: 'MapComponent',
    created() {
        this.getData()
    },
    data() {
        return {
            mapSection: {},
            map: {
                center: { lat: 47.0495926, lng: 8.3071034 },
                zoom: 16,
                tilt: 0,
                options: {
                    styles: this.appConstants.mapStyle,
                    scrollwheel: false,
                    navigationControl: false,
                    mapTypeControl: false,
                    scaleControl: false
                },
                marker: {
                    center: { lat: 47.0495926, lng: 8.3071034 },
                    icon: ''
                }
            }            
        }
    },
    methods: {
        getData() {
            const sections = this.$store.getters.getSections
            const mapSection = _find(sections, {type: 'map'})
            this.mapSection = mapSection
        }                
    }
}
</script>
